'use client'

import React, { useEffect, useState } from 'react'
import { motion, MotionProps, useScroll } from 'framer-motion'
import { cn } from '@/lib/utils'

type ScrollProgressProps = Omit<
  React.HTMLAttributes<HTMLElement>,
  keyof MotionProps
>

export const ScrollProgress = React.forwardRef<
  HTMLDivElement,
  ScrollProgressProps
>(({ className, ...props }, ref) => {
  const { scrollYProgress } = useScroll()
  const [isScrollable, setIsScrollable] = useState(false)

  // Check if the page is scrollable on component mount
  useEffect(() => {
    const updateScrollable = () => {
      const isContentScrollable =
        document.documentElement.scrollHeight > window.innerHeight
      setIsScrollable(isContentScrollable)
    }

    // Run on mount and when the window resizes
    updateScrollable()
    window.addEventListener('resize', updateScrollable)

    return () => window.removeEventListener('resize', updateScrollable)
  }, [])

  return (
    <motion.div
      ref={ref}
      className={cn(
        'fixed inset-x-0 top-0 z-50 h-0.5 origin-left bg-gradient-to-r from-[#A97CF8] via-[#F38CB8] to-[#FDCC92] bg-[length:200%_200%] animate-gradientMove',
        className
      )}
      style={{
        scaleX: isScrollable ? scrollYProgress : 1, // Set full width if not scrollable
      }}
      {...props}
    />
  )
})

ScrollProgress.displayName = 'ScrollProgress'
